import React from 'react';
import {brandFont} from '../brand';

export const EyebrowPill: React.FC<{label: string}> = ({label}) => (
  <div
    style={{
      fontFamily: brandFont,
      fontSize: 26,
      fontWeight: 600,
      color: 'rgba(255,255,255,0.54)',
      letterSpacing: 5.4,
      textShadow: '0 4px 20px rgba(0,0,0,0.6)',
      textAlign: 'center',
      textTransform: 'uppercase',
    }}
  >
    {label}
  </div>
);
